var e=typeof window!="undefined";export{e as default};
//# sourceMappingURL=is-running-on-client.js.map
